var map = {
	"./640cee.png": 486,
	"./alfabank.png": 487,
	"./android.png": 488,
	"./android_hover.png": 489,
	"./arrow_down.png": 490,
	"./arrow_down_gray.png": 491,
	"./arrow_up_gray.png": 492,
	"./asb.png": 493,
	"./asb_big.png": 494,
	"./bank-solution-small.png": 495,
	"./banner/hockey.png": 326,
	"./banner/soccer.png": 325,
	"./bapb-logo.png": 315,
	"./bapb-small.png": 496,
	"./belarusbank.png": 314,
	"./belgazprombank.png": 321,
	"./belinvest-small.png": 497,
	"./belveb-small.png": 498,
	"./belveb.png": 319,
	"./bg.png": 499,
	"./bgpb-small.png": 500,
	"./bib-logo.svg": 501,
	"./bib_logo.png": 313,
	"./big-logo.png": 74,
	"./bps-bank.png": 317,
	"./bps-small.png": 502,
	"./cash-minsk.png": 503,
	"./chat.png": 306,
	"./checkbox_sprite.png": 309,
	"./circle.png": 304,
	"./dark/dark_bg.png": 504,
	"./dark/dark_bg_wave.png": 505,
	"./erip.png": 506,
	"./erip_logo.png": 311,
	"./facebook.png": 201,
	"./flag.png": 507,
	"./go.png": 508,
	"./instagram.png": 509,
	"./ipay.png": 510,
	"./ipay_logo.png": 312,
	"./king.png": 511,
	"./left_menu_top.png": 512,
	"./left_menu_top_wb-1.png": 328,
	"./left_menu_top_wb-2.png": 329,
	"./link.png": 513,
	"./logo-light.png": 514,
	"./logo.png": 102,
	"./logo/bg1.png": 515,
	"./logo_mxl.png": 516,
	"./logo_test.png": 202,
	"./logo_v2.png": 196,
	"./logo_wb.png": 517,
	"./maestro.png": 518,
	"./mastercard.png": 519,
	"./minus.png": 520,
	"./mmbank-small.png": 521,
	"./mmbank.png": 324,
	"./mobile.png": 522,
	"./mtbank-small.png": 523,
	"./mtbank.png": 320,
	"./mts.png": 203,
	"./new_news.png": 524,
	"./news-attachment-1.png": 525,
	"./ok.png": 204,
	"./paritet-small.png": 526,
	"./paritet.png": 323,
	"./partners/fk-vitebsk-wb.svg": 527,
	"./partners/fk-vitebsk.png": 528,
	"./partners/fk-vitebsk.svg": 529,
	"./partners/hk-vitebsk-wb.svg": 530,
	"./partners/hk-vitebsk.svg": 531,
	"./payment-systems/erip.png": 532,
	"./payment-systems/ipay.png": 533,
	"./payment-systems/visa.png": 534,
	"./plus.png": 535,
	"./plus_gray.png": 307,
	"./pps/baranovichi/1.jpg": 205,
	"./pps/baranovichi/2.jpg": 206,
	"./pps/baranovichi/3.jpg": 207,
	"./pps/baranovichi/4.jpg": 208,
	"./pps/baranovichi/5.jpg": 209,
	"./pps/bobruisk/1.jpg": 210,
	"./pps/bobruisk/2.jpg": 211,
	"./pps/bobruisk/3.jpg": 212,
	"./pps/bobruisk/4.jpg": 213,
	"./pps/bobruisk/5.jpg": 214,
	"./pps/brest/1.JPG": 215,
	"./pps/brest/2.JPG": 216,
	"./pps/brest/3.JPG": 217,
	"./pps/brest/4.JPG": 218,
	"./pps/gomel/1.JPG": 219,
	"./pps/gomel/2.JPG": 220,
	"./pps/gomel/3.JPG": 221,
	"./pps/gomel/4.JPG": 222,
	"./pps/grodno/1.jpg": 223,
	"./pps/grodno/2.jpg": 224,
	"./pps/grodno/3.jpg": 225,
	"./pps/grodno/4.jpg": 226,
	"./pps/lida/1.JPG": 536,
	"./pps/lida/2.JPG": 537,
	"./pps/lida/3.JPG": 538,
	"./pps/lida/4.JPG": 539,
	"./pps/minsk/1.jpg": 227,
	"./pps/minsk/2.jpg": 228,
	"./pps/minsk/3.jpg": 229,
	"./pps/minsk/4.jpg": 230,
	"./pps/minsk/5.jpg": 231,
	"./pps/minsk/6.jpg": 232,
	"./pps/minsk/7.jpg": 233,
	"./pps/mogilev/1.jpg": 234,
	"./pps/mogilev/2.jpg": 235,
	"./pps/mogilev/3.jpg": 236,
	"./pps/mogilev/4.jpg": 237,
	"./pps/mozyr/1.jpg": 238,
	"./pps/mozyr/2.jpg": 239,
	"./pps/mozyr/3.jpg": 240,
	"./pps/mozyr/4.jpg": 241,
	"./pps/mozyr/5.jpg": 242,
	"./pps/novopolotsk/1.jpg": 243,
	"./pps/novopolotsk/2.jpg": 244,
	"./pps/novopolotsk/3.jpg": 245,
	"./pps/novopolotsk/4.jpg": 246,
	"./pps/novopolotsk/5.jpg": 247,
	"./pps/soligorsk/1.jpg": 540,
	"./pps/soligorsk/2.jpg": 541,
	"./pps/soligorsk/3.jpg": 542,
	"./pps/soligorsk/4.jpg": 543,
	"./pps/soligorsk/5.jpg": 544,
	"./pps/vitebsk/1.jpg": 248,
	"./pps/vitebsk/2.jpg": 249,
	"./pps/vitebsk/3.jpg": 250,
	"./pps/vitebsk/4.jpg": 251,
	"./pps/vitebsk/5.jpg": 252,
	"./priorbank-small.png": 545,
	"./priorbank.png": 316,
	"./qiwi.png": 310,
	"./reshenie_logo.png": 322,
	"./scroll_top.png": 546,
	"./smartphone.png": 547,
	"./sports/svg/1.svg": 70,
	"./sports/svg/10.svg": 122,
	"./sports/svg/11.svg": 123,
	"./sports/svg/12.svg": 124,
	"./sports/svg/13.svg": 125,
	"./sports/svg/14.svg": 126,
	"./sports/svg/15.svg": 127,
	"./sports/svg/16.svg": 128,
	"./sports/svg/17.svg": 129,
	"./sports/svg/18.svg": 130,
	"./sports/svg/19.svg": 131,
	"./sports/svg/2.svg": 132,
	"./sports/svg/20.svg": 133,
	"./sports/svg/21.svg": 134,
	"./sports/svg/22.svg": 135,
	"./sports/svg/24.svg": 136,
	"./sports/svg/26.svg": 137,
	"./sports/svg/27.svg": 138,
	"./sports/svg/28.svg": 139,
	"./sports/svg/3.svg": 140,
	"./sports/svg/30.svg": 141,
	"./sports/svg/31.svg": 142,
	"./sports/svg/32.svg": 143,
	"./sports/svg/33.svg": 144,
	"./sports/svg/34.svg": 145,
	"./sports/svg/35.svg": 146,
	"./sports/svg/37.svg": 147,
	"./sports/svg/38.svg": 148,
	"./sports/svg/4.svg": 149,
	"./sports/svg/40.svg": 150,
	"./sports/svg/42.svg": 151,
	"./sports/svg/43.svg": 152,
	"./sports/svg/44.svg": 153,
	"./sports/svg/46.svg": 154,
	"./sports/svg/48.svg": 155,
	"./sports/svg/5.svg": 156,
	"./sports/svg/50.svg": 157,
	"./sports/svg/51.svg": 158,
	"./sports/svg/52.svg": 159,
	"./sports/svg/55.svg": 160,
	"./sports/svg/56.svg": 161,
	"./sports/svg/57.svg": 162,
	"./sports/svg/59.svg": 163,
	"./sports/svg/6.svg": 164,
	"./sports/svg/62.svg": 165,
	"./sports/svg/66.svg": 166,
	"./sports/svg/7.svg": 167,
	"./sports/svg/73.svg": 168,
	"./sports/svg/8.svg": 169,
	"./sports/svg/80.svg": 170,
	"./sports/svg/83.svg": 171,
	"./sports/svg/86.svg": 172,
	"./sports/svg/87.svg": 173,
	"./sports/svg/89.svg": 174,
	"./sports/svg/9.svg": 175,
	"./sports/svg/95.svg": 176,
	"./sports/svg/all_sports.svg": 177,
	"./stars/star_2_gray.svg": 333,
	"./stars/star_2_hover.svg": 334,
	"./stars/star_gray.svg": 331,
	"./stars/star_hover.svg": 332,
	"./stars_sprite.png": 548,
	"./stats.png": 305,
	"./svg/play.svg": 549,
	"./svg/qiwi.svg": 550,
	"./svg/statistic.svg": 189,
	"./svg/timer.svg": 188,
	"./svg/tracker.svg": 551,
	"./svg/tv.svg": 552,
	"./techno-small.png": 553,
	"./tehnobank.png": 318,
	"./theme_sprite.png": 308,
	"./time.png": 554,
	"./timer.svg": 179,
	"./top-tourneys-1.png": 327,
	"./top-tourneys-2.png": 330,
	"./triangle_sprite.png": 555,
	"./tv_sprite.png": 335,
	"./velcom.png": 253,
	"./visa-mastercard.png": 101,
	"./visa.png": 556,
	"./vk.png": 254,
	"./youtube.png": 255
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 200;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = 200
// module chunks = 0